import React from "react";
import { Container, Grid, Card, Typography, Box } from "@mui/material";
import ScienceIcon from "@mui/icons-material/Science";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import WorkIcon from "@mui/icons-material/Work";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import SectionHeading from "./SectionHeading";
import { colors, fonts, ui } from "../theme";

const pillars = [
  {
    n: "01",
    icon: <ScienceIcon />,
    title: "Research & Innovation Enablement",
    objective: "Establish an institutional culture of original research, technical writing and scientific inquiry.",
    outcome: "More peer-reviewed publications and student-led patent filings.",
  },
  {
    n: "02",
    icon: <IntegrationInstructionsIcon />,
    title: "Academic Project Excellence",
    objective: "Transform student projects into high-quality, production-ready systems with version-controlled workflows.",
    outcome: "100% unique student assets on GitHub; zero template usage.",
  },
  {
    n: "03",
    icon: <WorkIcon />,
    title: "Experiential Internship Ecosystem",
    objective: "Bridge theory and industry expectations through milestone-driven, real-world internships.",
    outcome: "Career-ready students prepared for top-tier corporate placements.",
  },
  {
    n: "04",
    icon: <CastForEducationIcon />,
    title: "Faculty Development & Emerging Tech",
    objective: "Empower faculty with cloud, containers, microservices, AI/ML and cybersecurity skills.",
    outcome: "Upskilled, industry-certified faculty leading cutting-edge work.",
  },
];

const Pillars = () => {
  return (
    <section id="portfolio-section" className="portfolio-section">
      <Box sx={{ py: { xs: 5, md: 7 } }}>
        <Container>
          <SectionHeading
            eyebrow="Academic Transformation Portfolio"
            title="Four Strategic Pillars That Modernise Your Departments"
            subtitle="Every engagement is built on four reinforcing pillars — together delivering stronger accreditation performance, a vibrant innovation culture and long-term institutional growth."
          />
          <Grid container spacing={3}>
            {pillars.map((p) => (
              <Grid item xs={12} sm={6} lg={3} key={p.n}>
                <Card
                  elevation={0}
                  sx={{
                    ...ui.cardHover,
                    height: "100%",
                    p: 3,
                    borderRadius: 3,
                    border: "1px solid #e6edf7",
                    position: "relative",
                  }}
                >
                  <Typography
                    sx={{
                      position: "absolute",
                      top: 16,
                      right: 20,
                      fontFamily: fonts.heading,
                      fontWeight: 800,
                      fontSize: "2rem",
                      color: "#eef3fb",
                    }}
                  >
                    {p.n}
                  </Typography>
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      borderRadius: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: colors.blueTint,
                      color: colors.blueDark,
                      border: "1px solid rgba(56,182,255,0.22)",
                      mb: 2,
                    }}
                  >
                    {p.icon}
                  </Box>
                  <Typography
                    sx={{ fontFamily: fonts.heading, fontWeight: 700, color: colors.navy, mb: 1.2, fontSize: "1.05rem" }}
                  >
                    {p.title}
                  </Typography>
                  <Typography sx={{ color: colors.textMuted, fontSize: "0.9rem", lineHeight: 1.6, mb: 2 }}>
                    {p.objective}
                  </Typography>
                  <Box sx={{ borderTop: "1px dashed #dbe4f0", pt: 1.5 }}>
                    <Typography sx={{ color: colors.blueInk, fontWeight: 700, fontSize: "0.72rem", letterSpacing: "0.06em", mb: 0.5 }}>
                      STRATEGIC OUTCOME
                    </Typography>
                    <Typography sx={{ color: colors.navy, fontSize: "0.88rem", lineHeight: 1.5 }}>
                      {p.outcome}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </section>
  );
};

export default Pillars;
